import { axiosInstance } from "../../axios/axiosInstance";
import { ADMIN_API_URL, getDefaultHeaders } from "../../config";

const authHeaders = () => {
  const authToken = localStorage.getItem("authToken");
  return {
    ...getDefaultHeaders(),
    Authorization: `Bearer ${authToken}`,
  };
};

export const getFeatures = () =>
  axiosInstance.get(`${ADMIN_API_URL}/features`, {
    headers: authHeaders(),
  });

export const createFeatureRequest = ({ name_en, name_ar, status }) =>
  axiosInstance.post(
    `${ADMIN_API_URL}/features`,
    { name_en, name_ar, status },
    { headers: authHeaders() },
  );

export const updateFeatureRequest = (id, { name_en, name_ar, status }) =>
  axiosInstance.post(
    `${ADMIN_API_URL}/features/${id}`,
    { name_en, name_ar, status },
    { headers: authHeaders() },
  );

export const removeFeature = (id) =>
  axiosInstance.delete(`${ADMIN_API_URL}/features/${id}`, {
    headers: authHeaders(),
  });
